import { atom } from "jotai";

/**
 * Atom to store the currently selected IPDB model source / play name
 * Used for fetching XDA dimensions
 */
export const selectedIpdbModelSourceAtom = atom<string>("");

export interface XdaProjectionDimensions {
  leftWidth: number;
  rightWidth: number;
}

export const DEFAULT_RADIUS_WIDTH = 300;

export const xdaProjectionDimensionsAtom = atom<XdaProjectionDimensions>({
  leftWidth: DEFAULT_RADIUS_WIDTH,
  rightWidth: DEFAULT_RADIUS_WIDTH
});
